module.exports = __webpack_public_path__ + "img/thumb-023.ed0f1765.png";